"use strict";

var _interopRequireWildcard = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _core = require("echarts/core");
var _renderers = require("echarts/renderers");
var _charts = require("echarts/charts");
var _components = require("echarts/components");
var _vueEcharts = _interopRequireWildcard(require("vue-echarts"));
var _followUps = require("@/api/follow-ups");
var _utils = require("@/utils");
(0, _core.use)([_renderers.CanvasRenderer, _charts.PieChart, _components.TitleComponent, _components.TooltipComponent, _components.LegendComponent]);
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.startDate = '';
    this.endDate = '';
    this.option = {
      title: {
        text: 'Follow Up',
        left: 10,
        top: 10,
        textStyle: {
          color: '#121212',
          fontSize: 16,
          fontWeight: 'normal',
          fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
        }
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '18%',
        left: 'right',
        itemGap: 2,
        itemWidth: 15,
        itemHeight: 10
      },
      textStyle: {
        fontSize: 10,
        fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
      },
      series: [{
        name: 'Follow Up',
        bottom: 20,
        width: '100%',
        type: 'pie',
        radius: ['20%', '50%'],
        center: ['50%', '70%'],
        // adjust the start and end angle
        startAngle: 0,
        endAngle: 360,
        data: [{
          value: 0,
          name: 'Total'
        }, {
          value: 0,
          name: 'Completed'
        }, {
          value: 0,
          name: 'Missed'
        }],
        title: {
          fontSize: 10
        }
      }]
    };
  }
  created() {
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.fetchTotalFollowUpsCount();
      this.fetchCompletedFollowUpsCount();
      this.fetchMissedFollowUpsCount();
    }
  }
  async fetchTotalFollowUpsCount() {
    try {
      this.option.series[0].data[0].value = +(await (0, _followUps.getFollowUpsCount)((0, _utils.getQuery)({
        startDate: this.startDate,
        endDate: this.endDate
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchCompletedFollowUpsCount() {
    try {
      this.option.series[0].data[1].value = +(await (0, _followUps.getFollowUpsCount)((0, _utils.getQuery)({
        status: 'Completed',
        startDate: this.startDate,
        endDate: this.endDate
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchMissedFollowUpsCount() {
    try {
      this.option.series[0].data[2].value = +(await (0, _followUps.getFollowUpsCount)((0, _utils.getQuery)({
        status: 'Missed',
        startDate: this.startDate,
        endDate: this.endDate
      })));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'GaugeRingChart',
  components: {
    VChart: _vueEcharts.default
  },
  provide() {
    return {
      [_vueEcharts.THEME_KEY]: 'light'
    };
  }
})], default_1);
var _default = exports.default = default_1; // export default defineComponent({
//   name: 'GaugeRingChart',
//   components: {
//     VChart
//   },
//   provide: {
//     [THEME_KEY]: 'light'
//   },
//   props: {
//     dateRange: {
//       type: String,
//       required: true,
//       default: ''
//     }
//   },
//   setup() {
//     const option = ref({
//       title: {
//         text: 'Follow Up',
//         left: 10,
//         top: 10,
//         textStyle: {
//           color: '#121212',
//           fontSize: 16,
//           fontWeight: 'normal',
//           fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
//         }
//       },
//       textStyle: {
//         fontSize: 10,
//         fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif'
//       },
//       series: [
//         {
//           type: 'gauge',
//           startAngle: 90,
//           endAngle: -270,
//           pointer: {
//             show: false
//           },
//           progress: {
//             show: true,
//             overlap: false,
//             roundCap: true,
//             clip: false,
//             itemStyle: {
//               borderWidth: 1,
//               borderColor: '#464646'
//             }
//           },
//           axisLine: {
//             lineStyle: {
//               width: 20
//             }
//           },
//           splitLine: {
//             show: false,
//             distance: 0,
//             length: 10
//           },
//           axisTick: {
//             show: false
//           },
//           axisLabel: {
//             show: false,
//             distance: 50
//           },
//           data: [
//             {
//               value: 0,
//               name: 'Total',
//               title: {
//                 offsetCenter: ['0%', '-50%']
//               },
//               detail: {
//                 valueAnimation: true,
//                 offsetCenter: ['0%', '-30%']
//               }
//             },
//             {
//               value: 0,
//               name: 'Completed',
//               title: {
//                 offsetCenter: ['0%', '-8%']
//               },
//               detail: {
//                 valueAnimation: true,
//                 offsetCenter: ['0%', '10%']
//               }
//             },
//             {
//               value: 0,
//               name: 'Missed',
//               title: {
//                 offsetCenter: ['0%', '30%']
//               },
//               detail: {
//                 valueAnimation: true,
//                 offsetCenter: ['0%', '50%']
//               }
//             }
//           ],
//           title: {
//             fontSize: 10
//           },
//           detail: {
//             width: 8,
//             height: 5,
//             fontSize: 9,
//             color: 'inherit',
//             borderColor: 'inherit',
//             borderRadius: 5,
//             borderWidth: 0.5,
//             formatter: '{value}%'
//           }
//         }]
//     })
//     return { option }
//   },
//   created() {
//     if (dateRange.start && dateRange.end) {
//       startDate = dateRange.start
//       endDate = dateRange.end
//       this.fetchData()
//     } else if (!dateRange) {
//       const date = new Date()
//       endDate = date.toISOString()
//       date.setMonth(date.getMonth() - 2)
//       startDate = date.toISOString()
//     }
//     this.fetchTotalFollowUpsCount()
//     this.fetchCompletedFollowUpsCount()
//     this.fetchMissedFollowUpsCount()
//   },
//   methods: {
//     async fetchTotalFollowUpsCount() {
//       try {
//         this.option.series[0].data[0].value = +(await getFollowUpsCount(getQuery({ startDate: this.startDate, endDate: this.endDate })))
//       } catch (error) {
//         this.$notify({
//           title: 'Error',
//           type: 'error',
//           message: error.toString()
//         })
//       }
//     },
//     async fetchCompletedFollowUpsCount() {
//       try {
//         this.option.series[0].data[1].value = +(await getFollowUpsCount(getQuery({ status: 'Completed', startDate: this.startDate, endDate: this.endDate })))
//       } catch (error) {
//         this.$notify({
//           title: 'Error',
//           type: 'error',
//           message: error.toString()
//         })
//       }
//     },
//     async fetchMissedFollowUpsCount() {
//       try {
//         this.option.series[0].data[2].value = +(await getFollowUpsCount(getQuery({ status: 'Missed', startDate: this.startDate, endDate: this.endDate })))
//       } catch (error) {
//         this.$notify({
//           title: 'Error',
//           type: 'error',
//           message: error.toString()
//         })
//       }
//     }
//   }
// })